import React, { FC, useContext, useState } from 'react'

import { ProductTileV2 } from '@Components/ProductList/ProductTiles/LoadMore/ProductTileV2/ProductTileV2'
import { ProductTileWrapper } from '@Components/ProductList/ProductTileWrapper'
import { PromptDialog } from '@Domains/Cart/Components/Prompt/Dialog'
import { useAddToCart } from '@Domains/Cart/Hooks/useAddToCart'
import WishListHeader from '@Domains/Product/Features/WishList/Header'
import { UnWishedWrapper } from '@Domains/Product/Features/WishList/UnWishedWrapper'
import { AlgoliaProductTile } from '@Globals/Algolia/Types'
import { MetadataContext } from '@Globals/Metadata'

import styles from './WishList.module.scss'

interface WishListContentProps{
  id?: string
  tiles: AlgoliaProductTile[]
}

const WishListContent: FC<WishListContentProps> = ({ id, tiles }) => {
  const { storeURL } = useContext(MetadataContext)
  const [
    addToCart, {
      isLoading,
      prompts,
      reset,
      variables,
    },
  ] = useAddToCart()
  const [currentID, setCurrentID] = useState<string | null>(null)

  return (
    <div className={styles.wishListContent} id={id}>
      <WishListHeader count={tiles.length} />
      <ProductTileWrapper className={styles.items} maxColumns={4}>
        {tiles.map((tileData, index) => (
          <UnWishedWrapper key={`UnWishedWrapper_${tileData.id}`} id={tileData.id}>
            <ProductTileV2
              key={tileData.id}
              bottomChips={tileData.bottomChips}
              brand={tileData.brandTitle}
              bundleCombinedValue={tileData.bundleCombinedValue}
              className={styles.productCard}
              disableBuyButton={isLoading}
              enableHover
              hoverImage={tileData.hoverImage || undefined}
              isOutOfStock={tileData.isOutOfStock}
              loadingBuyButton={isLoading && currentID === tileData.id}
              onBuy={() => {
                if (currentID) {
                  return
                }

                setCurrentID(tileData.id)
                addToCart(
                  [
                    {
                      productID: tileData.id,
                      quantity: 1,
                      variantID: '',
                    },
                  ],
                  {
                    sourceID: 'wish_list_1',
                  },
                )
                  .finally(() => setCurrentID(null))
              }}
              originalPrice={tileData.beforePrice || tileData.price}
              overwrittenPrice={tileData.beforePrice ? tileData.price : undefined}
              primaryImage={tileData.primaryImage}
              priority={index < 20}
              productID={tileData.id}
              title={tileData.title}
              topChips={tileData.topChips}
              url={storeURL(tileData.url)}
            />
          </UnWishedWrapper>
        ))}
      </ProductTileWrapper>
      {prompts && prompts.length !== 0 && (
        <PromptDialog
          isLoading={isLoading}
          onClose={reset}
          onSubmit={addToCart}
          prompts={prompts}
          promptsOrigin={variables}
        />
      )}
    </div>
  )
}

export default WishListContent
